import script from "./TermsAndConditionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsList.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsList.vue?vue&type=style&index=0&id=ada69122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada69122"]])

export default __exports__